import DefaultRenderer from './Default'
import store from '../../store'
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class LeadershipRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    // store.resizeFn = this.onResize.bind(this);
    store.resizeFn = null
    store.section = 'terms'

    this.setHeaderStyle('white')
    this.onPageChange()
  }

  onEnter() {
    super.onEnter()
  }

  onLeave() {
    super.onLeave()
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }
}

export default LeadershipRenderer
